import { Component, EventEmitter,  Inject, Input, Output, OnInit} from 'ng-metadata/core';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {getVid} from "../../../appConfig/appConfigForward";
import { BriefResultService } from '../../briefResult/briefResult.service';
import { MediaQueries } from '../../../infra/mediaQueries.service';

const get= require('lodash/get');

let emptyArray = [];

@Component({
    "selector": "prm-search-result-journal-indication-line",
    templateUrl: 'components/search/searchResult/searchResultJournalIndication/searchResultJournalIndicationLine.html'
})

export class PrmSearchResultJournalIndicationLine implements OnInit{

    private journalLineIcons: Object[];
    private warningAttributes: string[] = [];
    private regularArttributes: string[] = [];

    @Input() public displayMode: string;
    @Input() private item: any;
    constructor(@Inject('journalLineIcons') journalLineIcons,
                private mediaQueries: MediaQueries,
                private briefResultService: BriefResultService) {
        this.journalLineIcons = journalLineIcons;
    }

    ngOnInit() {
        this.getItemsCdiAttributes();
    }

    isOpenaccess(){
        return ( get(this.item,'pnx.display.oa[0]') === 'free_for_read' || get(this.item,'pnx.addata.openaccess[0]') === 'true');
    }

    isPeerreviewed(){
         return (get(this.item, 'pnx.display.lds50[0]') === 'peer_reviewed' || get(this.item, 'pnx.addata.peerreview[0]') === 'true');
    }

    isCourseDocument() {
        return get(this.item, 'pnx.display.crsinfo[0]');
    }

    isEmail(){
        if(this.displayMode === 'email')
            return true;
        return false; 
    }

    isMobile(){
        return (this.mediaQueries.xs || this.mediaQueries.sm);
    }

    get isCdiAttributesDocument() {
        return (this.isCdiWarningAttributesDocument || this.isCdiRegulargAttributesDocument);
    }

    get isCdiWarningAttributesDocument() {
        return this.warningAttributes.length > 0;

    }

    get isCdiRegulargAttributesDocument() {
        return this.regularArttributes.length > 0;
    }

    public getItemsCdiAttributes() {
        let attributes: string[] = get(this.item, 'pnx.display.attribute')
        if (attributes){  
            this.removeDuplicates(attributes).forEach(element => {
                this.briefResultService.warningAttributesOrder.has(element) ? this.warningAttributes.push(element) : this.regularArttributes.push(element)
            });  
        }
    }

    get warningCdiAttributesItem() {
        return this.warningAttributes.sort((a,b) => { return this.briefResultService.warningAttributesOrder.get(a) - this.briefResultService.warningAttributesOrder.get(b)});;
    }

    get regularCdiAttributesItem() {
        return this.regularArttributes.sort((a,b) => { return this.briefResultService.regularAttributesOrder.get(a) - this.briefResultService.regularAttributesOrder.get(b)});;
    }

    get isCdiAttributesEnabledInBO(){
        return this.briefResultService.isCdiAttributesEnabledInBO;
    }

    private removeDuplicates(arr) {
        let arrWithoutDuplicates: string[] = [];
        arr.forEach(element => {
            if (!arrWithoutDuplicates.includes(element)) {
                arrWithoutDuplicates.push(element);
            }
        });
        return arrWithoutDuplicates;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultJournalIndication/searchResultJournalIndicationLine.directive.ts